// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t7-2";
export var chatLink = "_t7-0";
export var chatText = "_t7-1";